import React, { Component } from 'react';
import Header from "../component/header/Header";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import { withTranslation } from 'react-i18next';

 class error404 extends Component {
    
    render() {
        const { t } = this.props;
        return (
            <>
                <Header headerPosition="header--transparent" color="color-white" logo="logo-light" />
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-color">{t('error404.title')}</h1>
                                    <h3 className="sub-title">{t('error404.subtitle')}</h3>
                                    <span>{t('error404.description')}</span>
                                    <div className="error-button">
                                        <a className="btn-default" href="/">{t('error404.backHome')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
            </>
        )
    }
}
export default withTranslation()(error404);
